module.exports = __webpack_public_path__ + "img/icon_ranking.dab7f28a.png";